<div class="spend-grid grid-max-width grey-25-bg nordic-blue-900-text">
  <div class="header">
    <fin-text-toggle-button-group
      class="flex flex--middle ms-large-y flex--align-start"
      [buttons]="dateRangeButtons"
      (activeButtonName)="setFilter($event)"
      [translationPrefix]="'CORPORATE.corporatePortal.data.filter'"
      [ariaPrefix]="'CORPORATE.corporatePortal.data.aria'"
    ></fin-text-toggle-button-group>
  </div>
  @if ((isEmpty$ | async) === false || (data$ | async) === undefined) {
    <div class="kpis kpi-grid">
      <fin-kpi
        [title]="'CORPORATE.corporatePortal.data.kpi.totalSpend' | finLocalization"
        [value]="
          { amount: (data$ | async)?.datasets.at(1)?.total?.toString(), currencyCode: 'EUR' }
            | finPrice: { roundPrice: true }
        "
      ></fin-kpi>
      <fin-kpi
        [title]="'CORPORATE.corporatePortal.data.kpi.totalPassengers' | finLocalization"
        [value]="(data$ | async)?.datasets.at(0).total | number: '1.0-0'"
      ></fin-kpi>
      <fin-kpi
        [title]="'CORPORATE.corporatePortal.data.kpi.totalTrips' | finLocalization"
        [value]="(data$ | async)?.totalTrips | number: '1.0-0'"
      ></fin-kpi>
    </div>

    <div class="spend white-bg border rounded-large ps-medium-x ps-medium-y">
      <div class="flex flex--row flex--space-between">
        <h5 class="font-heading-5">{{ 'CORPORATE.corporatePortal.data.kpi.totalSpend' | finLocalization }} (€)</h5>
        <fin-toggle-button-group
          [buttons]="[
            {
              name: 'chart',
              icon: SvgLibraryIcon.TRACK_PLAYING,
              ariaLabel: 'CORPORATE.corporatePortal.data.aria.chart' | finLocalization,
            },
            {
              name: 'table',
              icon: SvgLibraryIcon.MENU_LIST_VIEW,
              ariaLabel: 'CORPORATE.corporatePortal.data.aria.table' | finLocalization,
            },
          ]"
          [name]="'spend'"
          (activeButtonName)="setDisplayMode('spend', $event)"
        ></fin-toggle-button-group>
      </div>

      <fin-corporate-data-table
        *ngIf="(data$ | async) && displayMode['spend'] === DataViewType.TABLE"
        [height]="'328px'"
        [rows]="(data$ | async)?.datasets.at(dataIndex.SPEND)?.rows"
        [xColumn]="{ translationKey: 'CORPORATE.corporatePortal.data.tables.month', type: XColumnType.DATE }"
        [currentDateFilter]="dataFiltersFormGroup.controls.dateFilter.value"
        [captionTranslationKey]="'CORPORATE.corporatePortal.data.charts.data.title'"
      ></fin-corporate-data-table>

      <fin-line-chart
        *ngIf="(data$ | async) && displayMode['spend'] === DataViewType.CHART"
        [height$]="328 | finToBehaviorSubject"
        [dynamicWidth]="true"
        [rows$]="(data$ | async)?.datasets.at(dataIndex.SPEND)?.rows | finToObservable"
        [unit]="'€'"
        [tiltXAxisText]="true"
        [isMobile]="isMobile$ | async"
        [legendText$]="
          'CORPORATE.corporatePortal.data.filter.' + dataFiltersFormGroup.controls.dateFilter.value
            | finLocalization
            | finToObservable
        "
      ></fin-line-chart>
      <div *ngIf="(data$ | async) === undefined" class="spend-chart flex flex--center flex--middle">
        <fcom-loader></fcom-loader>
      </div>
    </div>

    <div class="top-ten bar-chart white-bg border rounded-large ps-medium-x ps-medium-y">
      <div class="flex flex--row flex--space-between">
        <h3 class="font-heading-5">
          {{ 'CORPORATE.corporatePortal.data.charts.topTenTrips.title' | finLocalization }} (€)
        </h3>
        <fin-toggle-button-group
          [buttons]="[
            {
              name: 'chart',
              icon: SvgLibraryIcon.TRACK_PLAYING,
              ariaLabel: 'CORPORATE.corporatePortal.data.aria.chart' | finLocalization,
            },
            {
              name: 'table',
              icon: SvgLibraryIcon.MENU_LIST_VIEW,
              ariaLabel: 'CORPORATE.corporatePortal.data.aria.table' | finLocalization,
            },
          ]"
          [name]="'topTenTrips'"
          (activeButtonName)="setDisplayMode('topTenTrips', $event)"
        ></fin-toggle-button-group>
      </div>
      <fin-corporate-data-table
        *ngIf="(data$ | async) && displayMode['topTenTrips'] === DataViewType.TABLE"
        [height]="'318px'"
        [rows]="(data$ | async)?.datasets.at(dataIndex.TOP_TEN_TRIPS)?.rows"
        [xColumn]="{ translationKey: 'CORPORATE.corporatePortal.data.tables.trip', type: XColumnType.STRING }"
        [currentDateFilter]="dataFiltersFormGroup.controls.dateFilter.value"
        [captionTranslationKey]="'CORPORATE.corporatePortal.data.charts.topTenTrips.title'"
      ></fin-corporate-data-table>
      <fin-bar-chart
        *ngIf="(data$ | async) && displayMode['topTenTrips'] === DataViewType.CHART"
        [height$]="318 | finToBehaviorSubject"
        [dynamicWidth]="true"
        [tiltXAxisText]="true"
        [rows$]="(data$ | async)?.datasets.at(dataIndex.TOP_TEN_TRIPS)?.rows | finToObservable"
        [xAxisType]="BarChartXAxisType.STRING"
        [unit]="'€'"
        [legendText$]="
          'CORPORATE.corporatePortal.data.filter.' + dataFiltersFormGroup.controls.dateFilter.value
            | finLocalization
            | finToObservable
        "
      >
      </fin-bar-chart>
      <div *ngIf="(data$ | async) === undefined" class="bar-chart-area flex flex--center flex--middle">
        <fcom-loader></fcom-loader>
      </div>
    </div>

    <div class="ticket-types bar-chart white-bg border rounded-large ps-medium-x ps-medium-y">
      <div class="flex flex--row flex--space-between">
        <h5 class="font-heading-5">
          {{ 'CORPORATE.corporatePortal.data.charts.ticketTypes.title' | finLocalization }} (€)
        </h5>
        <fin-toggle-button-group
          [buttons]="[
            {
              name: 'chart',
              icon: SvgLibraryIcon.TRACK_PLAYING,
              ariaLabel: 'CORPORATE.corporatePortal.data.aria.chart' | finLocalization,
            },
            {
              name: 'table',
              icon: SvgLibraryIcon.MENU_LIST_VIEW,
              ariaLabel: 'CORPORATE.corporatePortal.data.aria.table' | finLocalization,
            },
          ]"
          [name]="'ticketTypes'"
          (activeButtonName)="setDisplayMode('ticketTypes', $event)"
        ></fin-toggle-button-group>
      </div>
      <fin-corporate-data-table
        *ngIf="(data$ | async) && displayMode['ticketTypes'] === DataViewType.TABLE"
        [height]="'318px'"
        [rows]="(data$ | async)?.datasets.at(dataIndex.TICKET_TYPES)?.rows.filter(tripsDomainFilter)"
        [xColumn]="{ translationKey: 'CORPORATE.corporatePortal.data.tables.ticketType', type: XColumnType.STRING }"
        [currentDateFilter]="dataFiltersFormGroup.controls.dateFilter.value"
        [captionTranslationKey]="'CORPORATE.corporatePortal.data.charts.ticketTypes.title'"
      ></fin-corporate-data-table>

      <fin-bar-chart
        *ngIf="(data$ | async) && displayMode['ticketTypes'] === DataViewType.CHART"
        [height$]="318 | finToBehaviorSubject"
        [dynamicWidth]="true"
        [rows$]="(data$ | async)?.datasets.at(dataIndex.TICKET_TYPES)?.rows | finToObservable"
        [xAxisType]="BarChartXAxisType.STRING"
        [domainFilter]="tripsDomainFilter"
        [unit]="'€'"
        [legendText$]="
          'CORPORATE.corporatePortal.data.filter.' + dataFiltersFormGroup.controls.dateFilter.value
            | finLocalization
            | finToObservable
        "
      >
      </fin-bar-chart>
      <div *ngIf="(data$ | async) === undefined" class="bar-chart-area flex flex--center flex--middle">
        <fcom-loader></fcom-loader>
      </div>
    </div>

    <div class="passengers bar-chart white-bg border rounded-large ps-medium-x ps-medium-y">
      <div class="flex flex--row flex--space-between">
        <h5 class="font-heading-5">
          {{ 'CORPORATE.corporatePortal.data.charts.passengers.title' | finLocalization }}
        </h5>
        <fin-toggle-button-group
          [buttons]="[
            {
              name: 'chart',
              icon: SvgLibraryIcon.TRACK_PLAYING,
              ariaLabel: 'CORPORATE.corporatePortal.data.aria.chart' | finLocalization,
            },
            {
              name: 'table',
              icon: SvgLibraryIcon.MENU_LIST_VIEW,
              ariaLabel: 'CORPORATE.corporatePortal.data.aria.table' | finLocalization,
            },
          ]"
          [name]="'passengers'"
          (activeButtonName)="setDisplayMode('passengers', $event)"
        ></fin-toggle-button-group>
      </div>
      <fin-corporate-data-table
        *ngIf="(data$ | async) && displayMode['passengers'] === DataViewType.TABLE"
        [height]="'318px'"
        [rows]="(data$ | async)?.datasets.at(dataIndex.PASSENGERS)?.rows"
        [xColumn]="{ translationKey: 'CORPORATE.corporatePortal.data.tables.month', type: XColumnType.DATE }"
        [currentDateFilter]="dataFiltersFormGroup.controls.dateFilter.value"
        [captionTranslationKey]="'CORPORATE.corporatePortal.data.charts.passengers.title'"
      ></fin-corporate-data-table>

      <fin-bar-chart
        *ngIf="(data$ | async) && displayMode['passengers'] === DataViewType.CHART"
        [height$]="318 | finToBehaviorSubject"
        [dynamicWidth]="true"
        [rows$]="(data$ | async)?.datasets.at(dataIndex.PASSENGERS)?.rows | finToObservable"
        [xAxisType]="BarChartXAxisType.DATE"
        [unit]="'CORPORATE.corporatePortal.data.units.passengers'"
        [tiltXAxisText]="true"
        [legendText$]="
          'CORPORATE.corporatePortal.data.filter.' + dataFiltersFormGroup.controls.dateFilter.value
            | finLocalization
            | finToObservable
        "
      >
      </fin-bar-chart>
      <div *ngIf="(data$ | async) === undefined" class="bar-chart-area flex flex--center flex--middle">
        <fcom-loader></fcom-loader>
      </div>
    </div>
  } @else {
    @if (error$ | async) {
      <div class="error flex flex--center flex--middle rounded-large border">
        <div class="error-text grey-25-bg align-center pr-xxlarge-y pr-medium-x font-body-1" data-testid="error">
          {{ 'CORPORATE.corporatePortal.data.error' | finLocalization }}<br />
        </div>
      </div>
    }
    @if (isEmpty$ | async) {
      <div class="error flex flex--center flex--middle rounded-large border">
        <div class="error-text grey-25-bg align-center pr-xxlarge-y pr-medium-x font-body-1" data-testid="empty">
          {{ 'CORPORATE.corporatePortal.data.empty' | finLocalization }}<br />
        </div>
      </div>
    }
  }
</div>
